export default __webpack_public_path__ + "assets/images/23e3e5eaf224c819318cc05d1b86b428.jpg";